import { render, staticRenderFns } from "./formbuilderTemplateDataList.vue?vue&type=template&id=a2630894"
import script from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
export * from "./formbuilderTemplateDataList.vue?vue&type=script&lang=js"
import style0 from "./formbuilderTemplateDataList.vue?vue&type=style&index=0&id=a2630894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports